import { t } from 'i18next';
import { fromJS } from 'immutable';
import { normalize } from 'normalizr';

import { mapListToRecords, normalizeList } from '@sophocles/entities/entityUtils';
import { UserOption, userOptionSchema } from '@sophocles/entities/UserOption/userOptionRecord';
import { addToast } from '@sophocles/features/toast';
import apiClient from '@sophocles/http-common';
import { setLanguage } from '@sophocles/i18n';
import { checkHttpStatus, genericErrorAction } from '@sophocles/utils';

/* Receive Actions */
export const RECEIVE_USER_OPTIONS = 'RECEIVE_USER_OPTIONS';
export function receiveUserOptions(json) {
  return {
    type: RECEIVE_USER_OPTIONS,
    userOptions: mapListToRecords(json, UserOption),
  };
}

/* Request Actions */
// starter request
export const REQUEST_USER_OPTION = 'REQUEST_USER_OPTION';
function requestUserOption(userOption_id) {
  return {
    type: REQUEST_USER_OPTION,
    userOption_id,
  };
}

export const REQUEST_USER_OPTIONS_FOR_USER = 'REQUEST_USER_OPTIONS_FOR_USER';
function requestUserOptionsForUser(user) {
  return {
    type: REQUEST_USER_OPTIONS_FOR_USER,
    user,
  };
}

/* Fetch Actions */
// starter fetch

export function fetchUserOption(userOption_id) {
  return dispatch => {
    dispatch(requestUserOption(userOption_id));
    return apiClient
      .get(`/useroptions/${userOption_id}/`)
      .then(checkHttpStatus)
      .then(response => normalizeList(response.data, 'userOptions', userOptionSchema))
      .then(json => dispatch(receiveUserOptions(json.entities.userOptions)))
      .catch(error => dispatch(genericErrorAction(error, REQUEST_USER_OPTION)));
  };
}

export function fetchUserOptionsForUser(user_id) {
  return dispatch => {
    dispatch(requestUserOptionsForUser(user_id));
    return apiClient
      .get(`/users/${user_id}/options/`)
      .then(checkHttpStatus)
      .then(response => normalizeList(response.data.results, 'userOptions', userOptionSchema))
      .then(json => dispatch(receiveUserOptions(json.entities.userOptions)))
      .catch(error => dispatch(genericErrorAction(error, REQUEST_USER_OPTIONS_FOR_USER)));
  };
}

/* Edit Actions */
export const EDIT_USER_OPTION = 'EDIT_USER_OPTION';
export function editUserOption(userOption_id) {
  return {
    type: EDIT_USER_OPTION,
    userOption: userOption_id,
  };
}

export function patchUserOption(userOption_id, values) {
  return dispatch => {
    dispatch(editUserOption(userOption_id));
    return apiClient
      .patch(`/useroptions/${userOption_id}/`, values)
      .then(checkHttpStatus)
      .then(json => {
        dispatch(
          addToast({
            title: t('general.success'),
            message: t('auth.notificationSettingsUpdated'),
            level: 'success',
            dismissible: true,
          }),
        );
        setLanguage(json.data.locale ?? 'en-US');
        dispatch(receiveUserOptions({ [json.data.id]: json.data }));
        return fromJS(json);
      })
      .catch(error => dispatch(genericErrorAction(error, EDIT_USER_OPTION)));
  };
}

/* Create Actions */
export const CREATE_USER_OPTION = 'CREATE_USER_OPTION';
function sayCreateUserOption(values) {
  return {
    type: CREATE_USER_OPTION,
    values: values,
  };
}

export function createUserOption(values) {
  return dispatch => {
    dispatch(sayCreateUserOption(values));
    return apiClient
      .post(`/useroptions/`, values)
      .then(checkHttpStatus)
      .then(response => normalize(response.data, userOptionSchema))
      .then(json => dispatch(receiveUserOptions(json.entities.userOptions)))
      .catch(error => dispatch(genericErrorAction(error, CREATE_USER_OPTION)));
  };
}

/* Delete Actions */
export const DELETE_USER_OPTION = 'DELETE_USER_OPTION';
function sayDeleteUserOption(userOption_id) {
  return {
    type: DELETE_USER_OPTION,
    userOption: userOption_id,
  };
}

export function deleteUserOption(userOption_id) {
  return dispatch =>
    apiClient
      .delete(`/useroptions/${userOption_id}/`)
      .then(checkHttpStatus)
      .then(r => dispatch(sayDeleteUserOption(userOption_id)))
      .catch(error => dispatch(genericErrorAction(error, DELETE_USER_OPTION)));
}
